import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const buyers = [{
  name: 'Martina G.',
  location: 'CABA'
}, {
  name: 'Lucía M.',
  location: 'Mendoza'
}, {
  name: 'Daniela R.',
  location: 'Rosario'
}, {
  name: 'Florencia B.',
  location: 'La Plata'
}, {
  name: 'Carolina L.',
  location: 'Córdoba'
}];
export function FloatingNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const initial = window.setTimeout(() => setVisible(true), 5000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setBuyer(buyers[Math.floor(Math.random() * buyers.length)]);
        setVisible(true);
      }, 850);
    }, 30000);
    return () => {
      window.clearTimeout(initial);
      window.clearInterval(cycle);
    };
  }, []);
  return <AnimatePresence data-id="element-94" data-mp="2fzarz5jh7eby">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 left-4 z-50 max-w-sm md:bottom-8 md:left-8" data-id="element-95" data-mp="20wn4g09gttsh">
          <div className="flex items-start gap-3 rounded-2xl border border-brand-gold/50 bg-white p-4 shadow-xl" data-id="element-96" data-mp="1mvkfnfr365dv">
            <div className="mt-0.5 rounded-full bg-brand-sageMist p-2" data-id="element-97" data-mp="1hyu4n6u51zzb">
              <CheckCircle2Icon className="h-5 w-5 text-brand-sageMid" data-id="element-98" data-mp="1d5hpdnbcn5j8" />
            </div>
            <div data-id="element-99" data-mp="186oc9vzz5gjl">
              <p className="mb-1 text-xs text-brand-muted" data-id="element-100" data-mp="1887rrkdt3nkb">🔔 Compra verificada • hace unos minutos</p>
              <p className="text-sm font-medium text-brand-text" data-id="element-101" data-mp="139o1x8w3drmo">
                <strong data-id="element-102" data-mp="z79jur08yvwg">{buyer.name}</strong> de {buyer.location} compró
              </p>
              <p className="text-sm font-bold text-brand-sageMid" data-id="element-103" data-mp="u7x1aigesazo">Cosmética Natural — La Guía Definitiva</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}